<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="oneway_search_form">
                <form action="#!">
                    <div class="row">
                        <div class="col-lg-3  col-md-6 col-sm-12 col-12 relative">
                            <div class="flight_Search_boxed">
                                <p>{{ $t('From') }}</p>
                                <input type="text" class="departure" name="departure" v-model="departure"
                                    @input="handle_airports_search" :placeholder="$t('City or Airport')"
                                    autocomplete="new-password">
                                <span class="departure_name">
                                    {{ departure_name }}
                                </span>
                                <div class="plan_icon_posation">
                                    <i class="fas fa-plane-departure"></i>
                                </div>
                            </div>
                            <ul v-if="is_searching" tabindex="0"
                                class="ui-id-1 ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                                style="top: 110px;z-index: 1060;left: 0px;text-align: initial;right: 0;">
                                <li class="fl-route-list ui-autocomplete-category ui-state-disabled ui-menu-item"
                                    aria-disabled="true">
                                    <a class="fl-routes ui-menu-item-wrapper" id="ui-id-8" tabindex="-1">
                                        {{ $t('Nearest airport') }}
                                    </a>
                                </li>
                                <li v-for="airport in airports_data" class="fl-route-list ui-menu-item"
                                    @click="selectAirport(airport)">
                                    <a class="fl-routes ui-menu-item-wrapper" tabindex="-1">
                                        <div class="inline-block airportMargin">
                                            <span class="fl-loc">
                                                {{ airport[this.$i18n.locale +
                                                    '_name'] }}
                                            </span>
                                            <span class="fl-country">
                                                {{ airport[this.$i18n.locale +
                                                    '_city'] }}
                                                ,
                                                {{ airport[this.$i18n.locale +
                                                    '_country'] }}
                                            </span>
                                        </div>
                                        <div class="pull-right">
                                            <h4 class="fl-route-code">
                                                {{ airport.code }}
                                            </h4>
                                        </div>
                                    </a>
                                </li>
                                <li v-if="noResults" class="fl-route-list ui-menu-item no-results">
                                    {{ $t('No results!') }}
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-3  col-md-6 col-sm-12 col-12 relative">
                            <div class="flight_Search_boxed">
                                <p>{{ $t('To') }}</p>
                                <input type="text" v-model="arrival" @input="handle_airports_search_oneway"
                                    :placeholder="$t('City or Airport')" autocomplete="new-password">
                                <span class="arrival_name">
                                    {{ arrival_name }}
                                </span>
                                <div class="plan_icon_posation">
                                    <i class="fas fa-plane-arrival"></i>
                                </div>
                                <div class="range_plan">
                                    <i class="fas fa-exchange-alt"></i>
                                </div>
                            </div>
                            <ul v-if="is_arrival_searching" tabindex="0"
                                class="ui-id-1 ui-menu ui-widget ui-widget-content ui-autocomplete ui-front"
                                style="top: 110px;z-index: 1060;left: 0px;text-align: initial;right: 0;">
                                <li class="fl-route-list ui-autocomplete-category ui-state-disabled ui-menu-item"
                                    aria-disabled="true">
                                    <a class="fl-routes ui-menu-item-wrapper" id="ui-id-8" tabindex="-1">
                                        {{ $t('Nearest airport') }}
                                    </a>
                                </li>
                                <li v-for="airport in airports_data" class="fl-route-list ui-menu-item"
                                    @click="selectAirportOneway(airport)">
                                    <a class="fl-routes ui-menu-item-wrapper" tabindex="-1">
                                        <div class="inline-block airportMargin">
                                            <span class="fl-loc">
                                                {{ airport[this.$i18n.locale
                                                    + '_name'] }}
                                            </span>
                                            <span class="fl-country">
                                                {{ airport[this.$i18n.locale
                                                    + '_city'] }}
                                                ,
                                                {{ airport[this.$i18n.locale
                                                    + '_country'] }}
                                            </span>
                                        </div>
                                        <div class="pull-right">
                                            <h4 class="fl-route-code">{{
                                                airport.code }}
                                            </h4>
                                        </div>
                                    </a>
                                </li>
                                <li v-if="noResults" class="fl-route-list ui-menu-item no-results">
                                    {{ $t('No results!') }}
                                </li>
                            </ul>
                        </div>
                        <div class="col-lg-4  col-md-6 col-sm-12 col-12">
                            <div class="form_search_date">
                                <div class="flight_Search_boxed date_flex_area">
                                    <div class="Journey_date">
                                        <p>{{ $t('Departure Date') }}</p>
                                        <VueDatePicker v-model="date" :enable-time-picker="false" :min-date="new Date()"
                                            @internal-model-change="handleInternal" 
                                            :placeholder="$t('Departure Date')" :start-date="new Date()"
                                            prevent-min-max-navigation />
                                        <span class="departure_day">
                                            {{ this.date ? $t(new
                                                Date(this.date).toLocaleDateString('en-US',
                                                    { weekday: 'long' })) : '' }}
                                        </span>
                                    </div>
                                    <div class="Journey_date">
                                        <p>{{ $t('Return Date') }}</p>
                                        <VueDatePicker v-model="arrival_date" :enable-time-picker="false"
                                            :min-date="date" :start-date="date"
                                            @internal-model-change="arrivalHandleInternal"
                                            :placeholder="$t('Return Date')" prevent-min-max-navigation />
                                        <span class="arrival_day">
                                            {{ this.arrival_date ? $t(new
                                                Date(this.arrival_date).toLocaleDateString('en-US',
                                                    { weekday: 'long' })) : '' }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1  col-md-6 col-sm-12 col-12 p-r-0">
                            <div class="flight_Search_boxed dropdown_passenger_area">
                                <p>{{ $t('Passengers') }}</p>
                                <div class="dropdown">
                                    <button class="dropdown-toggle final-count" type="button" data-toggle="dropdown"
                                        id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ number }} {{ $t('passenger') }}
                                    </button>
                                    <div class="dropdown-menu dropdown_passenger_info"
                                        aria-labelledby="dropdownMenuButton1">
                                        <div class="traveller-calulate-persons">
                                            <div class="passengers">
                                                <h6>{{ $t('Passengers') }}
                                                </h6>
                                                <div class="passengers-types">
                                                    <div class="passengers-type">
                                                        <div class="text">
                                                            <span class="count pcount">{{
                                                                pnumber
                                                                }}</span>
                                                            <div class="type-label">
                                                                <p>{{
                                                                    $t('Adult')
                                                                    }}</p>
                                                                <span>{{
                                                                    $t('morethan')
                                                                    }}
                                                                    12+
                                                                    {{
                                                                        $t('year')
                                                                    }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="button-set">
                                                            <button type="button" class="btn-add"
                                                                @click.stop="increment">
                                                                <i class="fas fa-plus"></i>
                                                            </button>
                                                            <button type="button" class="btn-subtract"
                                                                @click.stop="decrement">
                                                                <i class="fas fa-minus"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="passengers-type">
                                                        <div class="text">
                                                            <span class="count ccount">{{
                                                                cnumber
                                                                }}</span>
                                                            <div class="type-label">
                                                                <p class="fz14 mb-xs-0">
                                                                    {{
                                                                        $t('Child')
                                                                    }}
                                                                </p><span>
                                                                    {{
                                                                        $t('Lessthan')
                                                                    }} 12
                                                                    {{
                                                                        $t('year')
                                                                    }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="button-set">
                                                            <button type="button" class="btn-add-c"
                                                                @click.stop="incrementc">
                                                                <i class="fas fa-plus"></i>
                                                            </button>
                                                            <button type="button" class="btn-subtract-c"
                                                                @click.stop="decrementc">
                                                                <i class="fas fa-minus"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div class="passengers-type">
                                                        <div class="text">
                                                            <span class="count incount">{{
                                                                inumber
                                                                }}</span>
                                                            <div class="type-label">
                                                                <p class="fz14 mb-xs-0">
                                                                    {{
                                                                        $t('Infant')
                                                                    }}
                                                                </p><span>{{
                                                                    $t('Lessthan')
                                                                    }} 2
                                                                    {{
                                                                        $t('year')
                                                                    }}</span>
                                                            </div>
                                                        </div>
                                                        <div class="button-set">
                                                            <button type="button" class="btn-add-in"
                                                                @click.stop="incrementi">
                                                                <i class="fas fa-plus"></i>
                                                            </button>
                                                            <button type="button" class="btn-subtract-in"
                                                                @click.stop="decrementi">
                                                                <i class="fas fa-minus"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1  col-md-6 col-sm-12 col-12 p-r-0 ">
                            <div class="flight_Search_boxed dropdown_passenger_area">
                                <p>{{ $t('Class') }} </p>
                                <div class="dropdown">
                                    <button class="dropdown-toggle final-count" data-toggle="dropdown" type="button"
                                        id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        {{ $t(cabin) }}
                                    </button>
                                    <div class="dropdown-menu dropdown_passenger_info"
                                        aria-labelledby="dropdownMenuButton1">
                                        <div class="traveller-calulate-persons">
                                            <div class="cabin-selection">
                                                <h6>{{ $t('Cabin Class') }}</h6>
                                                <div class="cabin-list">
                                                    <button type="button" class="label-select-btn">
                                                        <input id="rb-eco" type="radio" v-model="cabin" name="cabin"
                                                            value="ECONOMY" class="chk-cabin">
                                                        <label for="rb-eco">
                                                            <span class="muiButton-label">
                                                                {{ $t('ECONOMY') }}
                                                            </span>
                                                        </label>
                                                    </button>
                                                    <button type="button" class="label-select-btn">
                                                        <input id="rb-bus" type="radio" v-model="cabin" name="cabin"
                                                            value="BUSINESS" class="chk-cabin">
                                                        <label for="rb-bus">
                                                            <span class="muiButton-label">
                                                                {{ $t('BUSINESS') }}
                                                            </span>
                                                        </label>
                                                    </button>
                                                    <button type="button" class="label-select-btn">
                                                        <input id="rb-firs" type="radio" v-model="cabin" name="cabin"
                                                            value="FIRST" class="chk-cabin">
                                                        <label for="rb-firs">
                                                            <span class="muiButton-label">
                                                                {{ $t('FIRST') }}
                                                            </span>
                                                        </label>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="top_form_search_button">
                        <button type="button" class="btn btn_theme btn_md btn-search-flight-next" @click="search">
                            {{ $t('Search Flight') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
import $ from 'jquery';
import { debounce } from 'lodash';
import { toast } from 'vue3-toastify';
import jsonData from '@/assets/file/airports-v2.json';

export default {
    name: "RoundtripSearchForm",
    props: [
        'view'
    ],
    data() {
        return {
            departure: null,
            departure_name: null,
            date: null,
            arrival: null,
            arrival_name: null,
            arrival_date: null,
            is_searching: false,
            is_arrival_searching: false,
            noResults: false,
            airports_data: [],
            cabin: 'ECONOMY',
            number: 1,
            pnumber: 1,
            cnumber: 0,
            inumber: 0,
            main_airport: {
                code: "RUH",
                ar_name: "مطار الملك خالد الدولي",
                en_name: "King Khalid Intl",
            },
        }
    },
    methods: {
        handle_airports_search_oneway: debounce(function (val) {
            this.searchAirPortsOneway(this.arrival);
        }, 500),
        searchAirPortsOneway(val) {
            this.noResults = false;
            if (val == '') {
                this.is_arrival_searching = false;
                return;
            } else {
                this.is_arrival_searching = true;
            }
            this.airports_data = jsonData.filter(item => {
                if (item.ar_name == null ||
                    item.code == null ||
                    item.ar_city == null ||
                    item.ar_state == null ||
                    item.ar_country == null ||
                    item.en_name == null ||
                    item.en_city == null ||
                    item.en_state == null ||
                    item.en_country == null) {
                    return false;
                } else {
                    return item.ar_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.code.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_country.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_country.toLowerCase().includes(val.toLowerCase());
                }

            });
            if (this.airports_data.length == 0) {
                this.noResults = true;
            }
        },
        selectAirportOneway(data) {
            this.is_arrival_searching = false;
            this.arrival = data['code'];
            this.arrival_name = data[this.$i18n.locale + '_name'];
        },
        handle_airports_search: debounce(function (val) {
            this.searchAirPorts(this.departure);
        }, 500),
        searchAirPorts(val) {
            this.noResults = false;
            if (val == '') {
                this.is_searching = false;
                return;
            } else {
                this.is_searching = true;
            }
            this.airports_data = jsonData.filter(item => {
                if (item.ar_name == null ||
                    item.code == null ||
                    item.ar_city == null ||
                    item.ar_state == null ||
                    item.ar_country == null ||
                    item.en_name == null ||
                    item.en_city == null ||
                    item.en_state == null ||
                    item.en_country == null) {
                    return false;
                } else {
                    return item.ar_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.code.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.ar_country.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_name.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_city.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_state.toLowerCase().includes(val.toLowerCase()) ||
                        item.en_country.toLowerCase().includes(val.toLowerCase());
                }

            });
            if (this.airports_data.length == 0) {
                this.noResults = true;
            }
        },
        selectAirport(data) {
            this.is_searching = false;
            this.departure = data['code'];
            this.departure_name = data[this.$i18n.locale + '_name'];
        },
        arrivalHandleInternal(date) {
            const dateStr1 = date;
            const dateStr2 = this.arrival_date;
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);
            if (date1 < date2 || date1 > date2) {
                setTimeout(() => {
                    $(document).find('.dp__action_select').click();
                }, 100);
            }
        },
        handleInternal(date) {
            const dateStr1 = date;
            const dateStr2 = this.date;
            const date1 = new Date(dateStr1);
            const date2 = new Date(dateStr2);
            if (date1 < date2 || date1 > date2) {
                setTimeout(() => {
                    $(document).find('.dp__action_select').click();
                }, 100);
            }
        },
        increment() {
            if ((parseInt(this.number)) < 9) {
                this.number++;
                this.pnumber++;
            } else {
                toast.error('تم بلوغ العدد الأقصى للركاب', {
                    autoClose: 2500,
                    position: toast.POSITION.TOP_RIGHT,
                    closeButton: true
                });
            }
        },
        decrement() {
            if (this.number === 0) return
            this.number -= 1

            if (this.pnumber === 0 || this.pnumber === 1) return

            this.pnumber -= 1
        },
        incrementc() {
            if ((parseInt(this.number)) < 9) {
                this.number++;
                this.cnumber++;
            } else {
                toast.error('تم بلوغ العدد الأقصى للركاب', {
                    autoClose: 2500,
                    position: toast.POSITION.TOP_RIGHT,
                    closeButton: true
                });
            }
        },
        decrementc() {
            if (this.number === 0) return
            this.number -= 1
            if (this.cnumber === 0) return
            this.cnumber -= 1
        },
        incrementi() {
            if ((parseInt(this.number)) < 9) {
                this.number++;
                this.inumber++;
            } else {
                toast.error('تم بلوغ العدد الأقصى للركاب', {
                    autoClose: 2500,
                    position: toast.POSITION.TOP_RIGHT,
                    closeButton: true
                });
            }
        },
        decrementi() {
            if (this.number === 0) return
            this.number -= 1
            if (this.inumber === 0) return
            this.inumber -= 1
        },
        search() {
            var from = this.departure,
                to = this.arrival,
                date = new Date(this.date).toLocaleDateString('sv-SE'),
                ret_date = new Date(this.arrival_date).toLocaleDateString('sv-SE');
            if (from == '' || to == '' || from == to) {
                toast.error(this.$t('Invalid Location'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else if (this.date == null || this.arrival_date == null || this.date > this.arrival_date) {
                toast.error(this.$t('Invalid Date'), {
                    autoClose: 3500,
                    position: toast.POSITION.TOP_CENTER,
                    closeButton: false
                });
            } else {
                var data = {
                    "from": from,
                    "to": to,
                    "date": date,
                    "ret_date": ret_date,
                    "currency": 'SAR',
                    "adults": this.pnumber,
                    "children": this.cnumber,
                    "infants": this.inumber,
                    "cabin": this.cabin,
                    "type": 'roundtrip'
                };
                this.$emit('search', data);
            }
        }
    },
    mounted() {
        var searchData = JSON.parse(localStorage.getItem("searchData"));
        var tripType = localStorage.getItem("tripType");
        if (this.view == 'result' && tripType == 'roundtrip') {
            this.cabin = searchData.cabin;
            this.date = new Date(searchData.date);
            this.arrival_date = new Date(searchData.ret_date);
            var departure = jsonData.filter(item => {
                return item.code.includes(searchData.from);
            })[0];

            this.departure = departure.code;
            this.departure_name = departure[this.$i18n.locale + '_name'];

            var arrival = jsonData.filter(item => {
                return item.code.includes(searchData.to);
            })[0];

            this.arrival = arrival.code;
            this.arrival_name = arrival[this.$i18n.locale + '_name'];
            
            this.inumber = searchData.infants;
            this.cnumber = searchData.children;
            this.pnumber = searchData.adults;
            this.number = this.inumber + this.cnumber + this.pnumber;
        }
    }
};
</script>